/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SettingsResourcesSubNav_viewer$ref: FragmentReference;
declare export opaque type SettingsResourcesSubNav_viewer$fragmentType: SettingsResourcesSubNav_viewer$ref;
export type SettingsResourcesSubNav_viewer = {|
  +email: ?string,
  +$refType: SettingsResourcesSubNav_viewer$ref,
|};
export type SettingsResourcesSubNav_viewer$data = SettingsResourcesSubNav_viewer;
export type SettingsResourcesSubNav_viewer$key = {
  +$data?: SettingsResourcesSubNav_viewer$data,
  +$fragmentRefs: SettingsResourcesSubNav_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsResourcesSubNav_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = 'c8c3eef97856712fa711824bb3cbb742';

module.exports = node;
